import { render, staticRenderFns } from "./androdH5Pay.vue?vue&type=template&id=2362a2a2"
import script from "./androdH5Pay.vue?vue&type=script&lang=js"
export * from "./androdH5Pay.vue?vue&type=script&lang=js"
import style0 from "./androdH5Pay.vue?vue&type=style&index=0&id=2362a2a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports